import { type UseQueryResult, useQuery } from 'react-query';
import {
  RsuAwardService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_AdminDashboardGrantList,
} from '../../services/wealthlane-award-services';
import { type TableParamsType } from '../../types/common';

const useGetRsuViewTableList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType,
  grantId: string,
  vestingDate: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_AdminDashboardGrantList | undefined,
  unknown
> => {
  const { filter, sorting, skipCount, maxResultCount } = tableInfo;
  const rsuViewTableList = useQuery(
    ['getRsuViewTableList', tableInfo, grantId, vestingDate],
    async () => {
      return await handleRequest(
        RsuAwardService.getApiAwardApiAppRSUAwardAdminDashboardGrantList(
          vestingDate,
          grantId,
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return rsuViewTableList;
};

export default useGetRsuViewTableList;
